import { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import classes from "../Dashboard/Profile.module.css";

const ChangePassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [passwordFields, setPasswordFields] = useState({
    newPassword: { field: "password", icon: "fa fa-eye" },
    confirmPassword: { field: "password", icon: "fa fa-eye" },
  });

  useEffect(() => {
    if(localStorage.getItem('linkedin-scheduler-token')) {
      navigate('/panel/dashboard')
    }
  }, [])

  // const oldPasswordRef = useRef();
  const newPasswordRef = useRef();
  const confirmPasswordRef = useRef();
  //   const passwordRef = useRef();

  const id = location.state?.id;

  // alert(id);
  if (!id) {
    // alert('ni od');
    window.location.href="/404";
    // navigate("/404");
  }

  const defaultValidationState = {
    // oldPassword: { invalid: false, message: "Please enter old password" },
    newPassword: { invalid: false, message: "Please enter new password" },
    confirmPassword: {
      invalid: false,
      message: "Please enter confirm password",
    },
    // password: { invalid: false, message: 'Please enter password' },
  };

  const [validateValues, setValidateValues] = useState(defaultValidationState);

  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isEmpty = (value) => !value || value.trim().length === 0;

  const submitHandler = async (event) => {
    setValidateValues(defaultValidationState);
    event.preventDefault();

    // const oldPassword = oldPasswordRef.current.value;
    const newPassword = newPasswordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;
    // const password = passwordRef.current.value;

    let isValid = true;

    // if (isEmpty(oldPassword)) {
    //   setValidateValues((prevState) => {
    //     return {
    //       ...prevState,
    //       oldPassword: { ...prevState.oldPassword, invalid: true },
    //     };
    //   });
    //   isValid = false;
    // }

    if (isEmpty(newPassword)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          newPassword: { ...prevState.newPassword, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(confirmPassword)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          confirmPassword: { ...prevState.confirmPassword, invalid: true },
        };
      });
      isValid = false;
    }

    // if(isEmpty(password)) {
    //   setValidateValues((prevState) => {
    //     return {...prevState, password: {...prevState.firstName, invalid: true}}
    //   });
    //   isValid = false;
    // }

    const formData = {};
    // const formData = new Object();

    if (isValid) {
      setIsLoading(true);

      // formData.oldPassword = oldPassword;
      formData.newPassword = newPassword;
      formData.confirmPassword = confirmPassword;
      formData.id = id;
      Object.freeze(formData);

      console.table(formData);

      try {
        const response = await fetch(
          process.env.REACT_APP_EXPRESS_URL + "/auth/change-password",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          const error = await response.json();

          if (response.status === 412) {
            console.table(error.errors);
            for (const key of error.errors) {
              setValidateValues((prevState) => {
                return {
                  ...prevState,
                  [key.path]: { message: [key.msg], invalid: true },
                };
              });
            }
          } else {
            setResponse((prevState) => {
              return { success: false, message: error.message };
            });
          }

          setTimeout(() => {
            setResponse(null);
          }, 3000);

          return;
        }
        const data = await response.json();

        setResponse((prevState) => {
          return { success: true, message: data.message };
        });

        setTimeout(() => {
          setResponse(null);
          navigate('/login');
        }, 3000);
      } catch (error) {
        setResponse((prevState) => ({
          success: false,
          message: "Something went wrong. Please try again.",
        }));
      } finally {
        setIsLoading(false); // Disable loader after receiving response (regardless of success or error)
      }
    }
  };

  const PasswordFieldHandler = (id) => {
    setPasswordFields((prevState) => {
      return {
        ...prevState,
        [id]: {
          field: prevState[id].field === "password" ? "text" : "password",
          icon:
            prevState[id].field === "password"
              ? "fa fa-eye-slash"
              : "fa fa-eye",
        },
      };
    });
  };

  const closeAlert = () => setResponse(null);

  return (
    <div className="flex h-screen bg-gray-900">
      {/* Left side with background image */}
      <div
        className="hidden md:flex w-1/2 h-full bg-cover bg-center"
        style={{
          backgroundImage:
            "url('/assets/login-bg-image-png.png')",
        }}
      >
        <div className="bg-opacity-50 w-full h-full flex items-center justify-center">
          <h1 className="text-white text-4xl font-bold max-w-md text-center">
            Schedule & Manage Your LinkedIn Posts Effortlessly 🚀
          </h1>
        </div>
      </div>

      {/* Right side with login form */}
      <div className="flex w-full md:w-1/2 items-center justify-center bg-gray-800 p-10">
        <div className="w-full max-w-md space-y-6">
          <div className="flex items-center justify-center gap-2 mb-4">
            {/* <img src="https://img.icons8.com/color/48/000000/linkedin.png" alt="logo" className="h-10 w-10" /> */}
            {/* <span className="text-white text-2xl font-bold">PostPro</span> */}
            <h1 className="text-3xl font-bold text-blue flex items-center gap-2">
              <i class="text-3xl fa fa-paper-plane"></i>
              PostPro
            </h1>
          </div>
          <div className="text-center">
            <h2 className="text-3xl font-semibold text-white">Reset Your Password</h2>
            {/* <p className="text-gray-400">Login to start scheduling your posts</p> */}
          </div>
          {/* <Loader /> */}
          {/* {isLoading && <Loader />} */}

          {response && !response.success && 
            (<div className="relative bg-rose-100 text-rose-600 px-4 py-3 rounded-lg text-sm border border-rose-300 transition-opacity duration-500 ease-in-out">
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-rose-500 hover:text-rose-700"
                aria-label="Close"
                onClick={closeAlert}
              >
                &times;
              </button>
            </div>)
          }
          {response && response.success && (
            <div className="bg-green-500 text-white px-4 py-2 rounded relative">
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-white"
                onClick={closeAlert}
              >
                ×
              </button>
            </div>
          )}
          <div className="w-full max-w-md space-y-6 relative">
            {isLoading && <Loader />}
            <form className="space-y-4" onSubmit={submitHandler}>
              <div>
                <label className="block mb-1 text-sm text-gray-300" htmlFor="newPassword">New Password</label>
                <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                  <input
                    type={passwordFields.newPassword.field}
                    className={`w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${validateValues.newPassword.invalid ? 'is-invalid' : ''}`}
                    autoFocus={true}
                    // className={`form-control ${validateValues.email.invalid ? 'is-invalid' : ''}`}
                    id="newPassword"
                    placeholder="Enter new password"
                    ref={newPasswordRef}
                    aria-describedby="newPassword-error"
                    aria-invalid="true"
                  />
                  <div className="border-l border-gray-600 px-3 cursor-pointer text-gray-400" onClick={() => PasswordFieldHandler("newPassword")}>
                    <i className={passwordFields.newPassword.icon}></i>
                  </div>
                </div>
                {validateValues.newPassword.invalid && (
                  <span id="email-error" className="text-rose-400 text-sm mt-1 block">
                    {validateValues.newPassword.message}
                  </span>
                )}
              </div>

              <div>
                <label htmlFor="confirmPassword" className="block mb-1 text-sm text-gray-300">Confirm Password</label>
                
                <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                  <input
                    type={passwordFields.confirmPassword.field}
                    id="confirmPassword"
                    className={`w-full pr-10 px-4 py-2 rounded-lg bg-gray-700 text-white focus:outline-none`}
                    placeholder="Enter confirm password"
                    ref={confirmPasswordRef}
                    aria-describedby={validateValues.confirmPassword.invalid ? "password-error" : undefined}
                    aria-invalid={validateValues.confirmPassword.invalid ? "true" : "false"}
                  />
                  <div className="border-l border-gray-600 px-3 cursor-pointer text-gray-400" onClick={()=> PasswordFieldHandler("confirmPassword")}>
                    <i className={passwordFields.confirmPassword.icon}></i>
                  </div>
                </div>

                {validateValues.confirmPassword.invalid && (
                  <span id="confirmPassword-error" className="text-rose-400 text-sm mt-1 block">
                    {validateValues.confirmPassword.message}
                  </span>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Change Password
              </button>

              {/* <div className="flex justify-between text-sm text-blue-400 mt-2"> */}
                {/* <Link to="/forgot/password">Forgot Password?</Link> */}
                {/* <a href="#" className="hover:underline">
                  Forgot Password?
                </a> */}
                {/* <a href="#" className="hover:underline">
                  Register
                </a> */}
                {/* <Link to="/signup">Register Yourself</Link> */}
              {/* </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
